const {
  SYSTEM_ADMIN,
  SUPER_ADMIN,
  CASE_MANAGER,
  OPERATIONAL_SUPPORT,
  STRATEGIST,
  STUDENT,
  EXTERNAL_STUDENT,
  TUTOR,
  HEAD_TUTOR,
  ACCOUNTS,
  SYSTEM_OPERATOR,
  BOT,
  REVIEWER,
  COMMUNITY_USER,
  COMMUNITY_ADMIN,
  COMMUNITY_MODERATOR,
  CGA_STUDENT,
  CGA_STAFF,
  RISE_STUDENT,
} = require('./roles.json');

const checkRole = (roles, str) => {
  if (!roles) {
    return false;
  }
  const list = roles.split(',');
  if (Array.isArray(list) || !!list.some) {
    return list.some(v => v === str);
  }

  if (typeof list === 'string') {
    return list === str;
  }

  return false;
};
/**
 * Determines if the user is a System Admin
 * @param {string} userRoles User's roles to check.
 */
const isSystemAdmin = userRoles => checkRole(userRoles, SYSTEM_ADMIN);

/**
 * Determines if the user is a Super Admin
 * @param {string} userRoles User's roles to check.
 */
const isSuperAdmin = userRoles => checkRole(userRoles, SUPER_ADMIN);

/**
 * Determines if the user is a Case Manager/Education Coordinator/Student Success Manager
 * @param {string} userRoles User's roles to check.
 */
const isCaseManager = userRoles => checkRole(userRoles, CASE_MANAGER);

/**
 * Determines if the user is Operational Support
 * @param {string} userRoles User's roles to check.
 */
const isOperationalSupport = userRoles =>
  checkRole(userRoles, OPERATIONAL_SUPPORT);

/**
 * Determines if the user is a Strategist
 * @param {string} userRoles User's roles to check.
 */
const isStrategist = userRoles => checkRole(userRoles, STRATEGIST);

/**
 * Determines if the user is a Student
 * @param {string} userRoles User's roles to check.
 */
const isStudent = userRoles => checkRole(userRoles, STUDENT);

/**
 * Determines if the user is an External Student
 * @param {string} userRoles User's roles to check.
 */
const isExternalStudent = userRoles => checkRole(userRoles, EXTERNAL_STUDENT);

/**
 * Determines if the user is a Tutor
 * @param {string} userRoles User's roles to check.
 */
const isTutor = userRoles => checkRole(userRoles, TUTOR);

/**
 * Determines if the user is a Head Tutor
 * @param {string} userRoles User's roles to check.
 */
const isHeadTutor = userRoles => checkRole(userRoles, HEAD_TUTOR);

/**
 * Determines if the user is a Bot
 * @param {string} userRoles User's roles to check.
 */
const isBot = userRoles => checkRole(userRoles, BOT);

/**
 * Determines if the user is in Accounts
 * @param {string} userRoles User's roles to check.
 */
const isAccounts = userRoles => checkRole(userRoles, ACCOUNTS);

/**
 * Determines if the user is a System Operator
 * @param {string} userRoles User's roles to check.
 */
const isSystemOperator = userRoles => checkRole(userRoles, SYSTEM_OPERATOR);

/**
 * Determines if the user is a Reviewer
 * @param {string} userRoles User's roles to check.
 */
const isReviewer = userRoles => checkRole(userRoles, REVIEWER);

/**
 * Determines if the user is a Community User
 * @param {string} userRoles User's roles to check.
 */
const isCommunityUser = userRoles => checkRole(userRoles, COMMUNITY_USER);

/**
 * Determines if the user is a Community Admin
 * @param {string} userRoles User's roles to check.
 */
const isCommunityAdmin = userRoles => checkRole(userRoles, COMMUNITY_ADMIN);

/**
 * Determines if the user is a Community Moderator
 * @param {string} userRoles User's roles to check.
 */
const isCommunityModerator = userRoles =>
  checkRole(userRoles, COMMUNITY_MODERATOR);

/**
 * Determines if the user is a CGA staff
 * @param {string} userRoles User's roles to check.
 */
const isCGAStaff = userRoles => checkRole(userRoles, CGA_STAFF);

/**
 * Determines if the user is a CGA student
 * @param {string} isCGAStudent User's roles to check.
 */
const isCGAStudent = userRoles => checkRole(userRoles, CGA_STUDENT);

/**
 * Determines if the user is a RISE student
 * @param {string} isRISEStudent User's roles to check.
 */
const isRISEStudent = userRoles => checkRole(userRoles, RISE_STUDENT);

/**
 * Determines if the user is an Admin
 * @param {string} userRoles User's roles to check.
 */
const isAdmin = userRoles =>
  isSuperAdmin(userRoles) || isCaseManager(userRoles);

module.exports = {
  isCommunityUser,
  isCommunityAdmin,
  isCommunityModerator,
  isSystemAdmin,
  isSuperAdmin,
  isCaseManager,
  isOperationalSupport,
  isStrategist,
  isStudent,
  isExternalStudent,
  isTutor,
  isHeadTutor,
  isAccounts,
  isAdmin,
  isBot,
  isSystemOperator,
  isReviewer,
  isCGAStaff,
  isCGAStudent,
  isRISEStudent,
};
